import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { Search } from '@mui/icons-material';
import { MuiButton, InputType } from '@ace/ace-ui-web';
import { motion } from 'framer-motion';
import FormField from '../formfield';

interface EmployeeSearchProps {
    searchValue: string;
    onSearchChange: (value: string) => void;
    onSearch: (e?: React.FormEvent) => void;
    disabled?: boolean;
}

export const EmployeeSearch: React.FC<EmployeeSearchProps> = ({
    searchValue,
    onSearchChange,
    onSearch,
    disabled = false,
}) => {
    return (
        <Box sx={{ maxWidth: '600px', margin: '0 auto 12px auto' }}>
            <form onSubmit={onSearch}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                    <Search sx={{ fontSize: 15, color: 'gray' }} />
                    <Typography
                        variant="body2"
                        sx={{ fontWeight: 500, fontSize: '0.875rem', fontFamily: 'var(--font-body)' }}
                    >
                        Search Employee
                    </Typography>
                </Box>
                <Stack direction="row" spacing={2} alignItems="flex-start">
                    <Box sx={{ flex: 1 }}>
                        <FormField
                            label="Search Employee"
                            hideLabel
                            value={searchValue}
                            onChange={(e) => onSearchChange(e.target.value)}
                            placeholder="Enter Employee ID"
                            type={InputType.Number}
                        />
                    </Box>
                    <motion.div whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
                        <MuiButton
                            size="large"
                            onClick={() => onSearch()}
                            sx={{ height: '44px' }}
                            disabled={disabled}
                        >
                            Search
                        </MuiButton>
                    </motion.div>
                </Stack>
            </form>
        </Box>
    );
};